// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"_1UZTn","wrapper":"_3IY4k","card":"_3kOhk","illustration":"_60VCO","referContainer":"_201hL"};